import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ArrivalsBoardService {

    private baseUrl = `${environment.apiUrl}`;

    constructor(private http: HttpClient) { }

    /**
     * Load today's arrivals from the reservations agent-list endpoint,
     * pre-filtered to today's check-in date and active statuses.
     */
    getTodayArrivals(checkInDate: string): Observable<any> {
        let params = new HttpParams()
            .append('checkInDateTime', checkInDate)
            .append('reservationStatus', 'OP')
            .append('size', '200')
            .append('page', '0')
            .append('sort', 'checkInDateTime,asc');
        return this.http.get<any>(`${this.baseUrl}/reservations/agent-list`, { params }).pipe(retry({ count: 2, delay: 1500 }));
    }

    /**
     * Query str_msg for arrival SMS records sent on the given date.
     * Returns { sentByReservationId: { "12345": { sentAt: "2:34 PM", msgId: 9876 }, ... } }
     */
    getSmsStatus(checkInDate: string): Observable<any> {
        let params = new HttpParams().append('checkInDate', checkInDate);
        return this.http.get<any>(`${this.baseUrl}/arrivals-board/sms-status`, { params })
            .pipe(retry({ count: 1, delay: 1000 }));
    }

    /**
     * Trigger the daily arrivals dashboard report job on-demand.
     */
    triggerDailyReport(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/report-dashboard/daily-arrivals/run`, {});
    }

    /**
     * Send the arrival SMS for a reservation.
     * Records the send in str_msg (topic=RESERVATION, msgSendType=SMS, status=SENT)
     * so all sessions see the sent status on next poll.
     */
    sendArrivalSms(smsPayload: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/arrivals-board/send-arrival-sms`, smsPayload);
    }
}
